import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import FooterApi from "../../../interface/api/site/footer";

interface TemplateProps {
    className?: string;
    children?: React.ReactNode;
}

interface FooterInfo {
    ceo: string | null;
    businessNumber: string | null;
    phone: string | null;
    fax: string | null;
    address: string | null;
}

export const UserTemplate1 = (props: TemplateProps) => {
    const [siteInfo] = useState(JSON.parse(localStorage.getItem("siteInfo") || "null"));
    const [footerInfo, setFooterInfo] = useState<FooterInfo>({
        ceo: "",
        businessNumber: "",
        phone: "",
        fax: "",
        address: "",
    });

    useEffect(() => {
        FooterApi.getFooterInfo(siteInfo.seq).then((res) => {
            if (res.status === 200) {
                setFooterInfo(res.data);
            }
        });
    }, []);

    return (
        <>
            <div className={props.className}>
                <Header siteInfo={siteInfo} />
                {props.children}
                <Footer footerInfo={footerInfo} />
            </div>
        </>
    );
};

UserTemplate1.defaultProps = {
    className: "user nv_wrap",
};

function Header({ siteInfo }: { siteInfo: any }) {
    const [lnbFlag, setLnbFlag] = useState<boolean>(false);
    const logoClass =
        siteInfo?.name === "솔브레인에스엘디"
            ? "sld"
            : siteInfo?.name === "솔브레인홀딩스"
                ? "holdings"
                : siteInfo?.name === "MC솔루션"
                    ? "mc"
                    : "normal";

    return (
        <div className="nv_header">
            <header>
                {siteInfo && (
                    <h1 className={`nv_logo ${logoClass}`}>
                        <Link to="/visit">방문예약시스템</Link>
                    </h1>
                )}

                <p className="pc_skip nv_toggle" onClick={() => setLnbFlag(true)}>모바일 메뉴 열기</p>
                <nav className={lnbFlag ? "nv_nav on" : "nv_nav"}>
                    <ul className="nv_level1">
                        <li className="nv_level1">
                            <p>방문신청</p>
                            <ul className="nv_level2">
                                <li className="nv_level2" onClick={() => setLnbFlag(false)}>
                                    <Link to="/visit/application">방문신청</Link>
                                </li>
                                <li className="nv_level2" onClick={() => setLnbFlag(false)}>
                                    <Link to="/visit/history">방문신청 진행보기</Link>
                                </li>
                            </ul>
                        </li>
                        <li className="nv_level1">
                            <p>장기출입신청</p>
                            <ul className="nv_level2">
                                <li className="nv_level2" onClick={() => setLnbFlag(false)}>
                                    <Link to="/visit/application?type=long">장기출입신청</Link>
                                </li>
                                <li className="nv_level2" onClick={() => setLnbFlag(false)}>
                                    <Link to="/visit/history?type=long">장기출입신청 진행보기</Link>
                                </li>
                            </ul>
                        </li>
                        <li className="nv_level1">
                            <p>공지사항</p>
                            <ul className="nv_level2">
                                <li className="nv_level2" onClick={() => setLnbFlag(false)}>
                                    <Link to="/visit/notice">공지사항</Link>
                                </li>
                            </ul>
                        </li>
                        <li className="nv_level1">
                            <p>FAQ</p>
                            <ul className="nv_level2">
                                <li className="nv_level2" onClick={() => setLnbFlag(false)}>
                                    <Link to="/visit/faq">FAQ</Link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
                <p className="pc_skip nv_toggle_close">모바일 메뉴 닫기</p>
            </header>
        </div>
    );
}

function Footer({ footerInfo }: { footerInfo: FooterInfo }) {
    return (
        <footer className="nv_footer">
            <ul className="nv_footer_top">
                <li><a href="https://www.soulbrain.co.kr/board/board.php?bo_table=info&idx=25" className="nv_blue">개인정보처리방침</a></li>
                <li><a href="#a">이용약관</a></li>
            </ul>
            <div className="nv_footer_bottom">
                <ul>
                    {footerInfo.ceo !== null && <li>대표이사 : {footerInfo.ceo}</li>}
                    {footerInfo.businessNumber !== null && <li>사업자번호: {footerInfo.businessNumber}</li>}
                    {footerInfo.address !== null && <li>{footerInfo.address}</li>}
                    {footerInfo.phone !== null && <li>TEL. {footerInfo.phone}</li>}
                    {footerInfo.fax !== null && <li>FAX. {footerInfo.fax}</li>}
                </ul>
                <address>COPYRIGHT 2020 Soulbrain Co., Ltd. ALL RIGHTS RESERVED.</address>
            </div>
        </footer>
    );
}

function TermsModal({ setStepModal }: { setStepModal: (flag: boolean) => void }) {
    return (
        <div className="modal edu_modal modal2 on">
            <div className="modal_con">
                <div className="edu_slide_box">
                    <div className="owl-carousel owl-theme" style={{ display: "block" }} />
                </div>
                <div className="nv_btn_area">
                    <button
                        type="button"
                        className="nv_btn_blue modal_close"
                        onClick={() => setStepModal(false)}
                    >
                        닫기
                    </button>
                </div>
            </div>
        </div>
    );
}
